import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Laryngoscopy in Delhi, India | Procedure, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get professional laryngoscopy in Delhi, India. Learn about procedure, diagnosis, treatment, and cost at MedFirst ENT Centre." />
            <meta name="keywords" content="Best Doctors for Laryngoscopy in Delhi" />
            <link rel="canonical" href="" />
            <meta property="og:title" content="Laryngoscopy in Delhi, India | Procedure, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get professional laryngoscopy in Delhi, India. Learn about procedure, diagnosis, treatment, and cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
